import axios from "axios";

export async function userTracking(trackingData) {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_DEALER_DASHBOARD_API_URL}/api/v1/user-tracking`,
      trackingData
    );
    return res;
  } catch (error) {
    console.log(error);
    return;
  }
}
